require.register("modules/m0x/a04/page-44-il-ny/page-44-il-ny", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_45il = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_45il;

  
});

